// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"hidden-alert_visuallyHidden__4f8a0"};